import { useCaptureStore } from '../../../stores/captureStore';
import { useSessionStore } from '../../../stores/sessionStore';
import { useCaptureRunStore, type CaptureRunLog } from '../../../stores/captureRunStore';

/** Captura viva de Emails/Telefones da pessoa, para o cabeçalho. */
export function useLiveRun(): CaptureRunLog | null {
  const userId = useSessionStore((s) => s.session?.userId ?? '');
  const phase = useCaptureStore((s) => s.phase);
  const module = useCaptureStore((s) => s.module);
  const activeListId = useCaptureStore((s) => s.activeListId);
  const log = useCaptureRunStore((s) =>
    module === 'emails' || module === 'phones' ? s.logs[module] : undefined,
  );
  if (!log || log.userId !== userId || !activeListId || log.listId !== activeListId) return null;
  if (phase !== 'running' && phase !== 'paused') return null;
  return log;
}
